const dropdownArr: (() => void)[] = [];

type DropdownLayer = {
  hide: () => void;
  contains: (node: Node) => boolean;
};

const layers: DropdownLayer[] = [];

function onKeydownCapture(event: KeyboardEvent) {
  if (event.key !== 'Escape' || !dropdownArr.length) return;
  event.stopImmediatePropagation();
  event.preventDefault();
  dropdownArr[dropdownArr.length - 1]();
}

function findLayerIndex(hide: () => void) {
  for (let index = layers.length - 1; index >= 0; index--) {
    if (layers[index].hide === hide) {
      return index;
    }
  }

  return -1;
}

export function startEscapeCapture(hide: () => void) {
  if (!dropdownArr.length) document.addEventListener('keydown', onKeydownCapture, true);
  dropdownArr.push(hide);
}

export function stopEscapeCapture(hide: () => void) {
  const index = dropdownArr.lastIndexOf(hide);
  if (index !== -1) dropdownArr.splice(index, 1);
  if (!dropdownArr.length) document.removeEventListener('keydown', onKeydownCapture, true);
}

export function startDropdownLayer(hide: () => void, contains: (node: Node) => boolean) {
  layers.push({ hide, contains });
}

export function stopDropdownLayer(hide: () => void) {
  const index = findLayerIndex(hide);
  if (index !== -1) layers.splice(index, 1);
}

export function isInsideChildDropdownLayer(hide: () => void, node: Node) {
  const index = findLayerIndex(hide);
  if (index === -1) return false;
  return layers.slice(index + 1).some((layer) => layer.contains(node));
}
